// NOTICE: KAPTION-INTEGRATION
/* global axios */
import ApiClient from './ApiClient';

class KaptionCopilot extends ApiClient {
  constructor() {
    super('kaption_copilot', { accountScoped: true });
  }

  fetchToken(conversationId = null) {
    const params = conversationId ? { conversation_id: conversationId } : {};
    return axios.get(`${this.url}/token`, { params });
  }
}

export default new KaptionCopilot();
